<template>
    <modal :containerClass="'w-30'">
        <div class="modal-contour vertical-center" :class="'border-' + theme">
            <div class="p-0 form-group text-center">
                <h4 class="text-bold m-0" :class="'text-' + theme">{{ msg }}</h4>
            </div>
        </div>
    </modal>
</template>

<script>
    import Modal from "./Modal";
    export default {
        name: "ModalSuccessMessage",
        components: {Modal},
        props: ['theme', 'msg']
    }
</script>
